module.exports = __webpack_public_path__ + "static/media/gray_08.24f3cf5d.jpg";